import { RiddleComponent } from '@src/interfaces';
import React, { useEffect } from 'react';
import styles from '@src/utils/styles';
import { loadScript } from '@src/utils/scripts';

interface RiddleAPI {
  update(): void;
}

const Riddle = ({ riddleId, title }: Pick<RiddleComponent, 'riddleId' | 'title'>) => {
  const url = `https://www.riddle.com/a/${riddleId}`;
  useEffect(() => {
    styles.loadStyle('https://www.riddle.com/files/css/embed.css');
    loadScript<RiddleAPI>('https://www.riddle.com/files/js/embed.js', 'riddleAPI').then(
      riddleAPI => {
        riddleAPI.update();
      },
    );
  }, []);
  return (
    <div
      className="riddle_target"
      data-auto-scroll="false"
      data-auto-scroll-offset="0"
      data-rid-id={riddleId}
      style={{
        marginBottom: '24px',
      }}
    >
      <iframe src={url} title={title} />
    </div>
  );
};

export default Riddle;
